import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, MenuItem, Button, Divider } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useCompany } from "../../../context/CompanyContext";
import { useSnackbar } from "../../../context/SnackbarContext";
import { useLanguage } from "../../../context/LanguageContext";
import MDButton from "components/MDButton";

function CompanyDropdown() {
  const [anchorEl, setAnchorEl] = useState(null);
  const { companies, selectedCompany, setSelectedCompany } = useCompany();
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const { t } = useLanguage();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCompanySelect = async (company) => {
    await setSelectedCompany(company);
    setAnchorEl(null);
    navigate(`/documents?company_id=${company.id}`);
    showSnackbar(t("companySelected").replace("{name}", company.name), "success");
  };

  return (
    <div>
      <MDButton
        variant="contained"
        color="info"
        aria-controls="company-menu"
        aria-haspopup="true"
        onClick={handleMenuClick}
        endIcon={<ArrowDropDownIcon />}
      >
        {selectedCompany ? selectedCompany.name : t("selectCompany")}
      </MDButton>
      <Menu
        id="company-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {companies.map((company) => (
          <MenuItem key={company.id} onClick={() => handleCompanySelect(company)}>
            {company.name}
          </MenuItem>
        ))}

        {/* Skiriamoji juosta tarp sąrašo ir "Add Company" */}
        <Divider />

        <MenuItem onClick={() => navigate("/company-management")}>
          <i className="bi bi-plus-circle"></i> {t("addCompany")}
        </MenuItem>
      </Menu>
    </div>
  );
}

export default CompanyDropdown;
